import { useI18N } from "@sundae/react-hooks";
import { Balance, FlexList, FlexListItem, Text, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC } from "react";
import { useProfileAppContext } from "../../../stores";
import { useMigrateLiquidityContext } from "../../Dialogs/MigrateLiquidityDialog/context";
import { EMigrationTransactionBuilderState } from "../../Dialogs/MigrateLiquidityDialog/types";
import TextLoadingPlaceholder from "../../TextLoadingPlaceholder";

const LiquidityMigrationTransactionFees: FC = () => {
  const { currentLocale, t } = useI18N("fees");
  const {
    state: { privacyEnabled },
  } = useProfileAppContext();
  const {
    derived: { fees },
    transaction: { builderState, completeTx },
  } = useMigrateLiquidityContext();
  const isBuildingTx = builderState === EMigrationTransactionBuilderState.BUILD;

  return (
    <FlexList
      className={cx(
        "rounded-bl-lg rounded-br-lg border-t-0",
        toolkitCx.layout.spacing.both.md,
        toolkitCx.layout.border.default,
        toolkitCx.layout.border.weight.default
      )}
    >
      <FlexListItem
        field={{
          label: (
            <Text size="sm" tag="span" variant="muted">
              {t("fee", { context: "adaTx", ns: "fees" })}
            </Text>
          ),
          variant: "muted",
        }}
        tooltip={t("fee", {
          context: !completeTx ? "adaTxExplainedNextStep" : "adaTxExplained",
          ns: "fees",
        })}
        value={{
          label: isBuildingTx ? (
            <TextLoadingPlaceholder />
          ) : (
            <div className="inline-flex gap-[2px]">
              <Balance
                abbreviate={false}
                locale={currentLocale}
                privacy={privacyEnabled}
                showSymbol
                size="sm"
                variant="muted"
                // @ts-ignore
                value={fees?.adaTxFee} // TODO: replace with value from SDK
              />
            </div>
          ),
        }}
      />

      <FlexListItem
        field={{
          label: (
            <Text size="sm" tag="span" variant="muted">
              {t("fee", { context: "scooper", ns: "fees" })}
            </Text>
          ),
          variant: "muted",
        }}
        tooltip={t("fee", { context: "scooperExplained", ns: "fees" })}
        value={{
          label: isBuildingTx ? (
            <TextLoadingPlaceholder />
          ) : (
            <Balance
              abbreviate={false}
              locale={currentLocale}
              privacy={privacyEnabled}
              showSymbol
              size="sm"
              variant="muted"
              value={fees?.scooperFee} // TODO: replace with value from SDK
            />
          ),
        }}
      />

      <FlexListItem
        field={{
          label: (
            <Text size="sm" tag="span" variant="muted">
              {t("fee", { context: "deposit", ns: "fees" })}
            </Text>
          ),
          variant: "muted",
        }}
        tooltip={t("fee", { context: "depositExplained", ns: "fees" })}
        value={{
          label: isBuildingTx ? (
            <TextLoadingPlaceholder />
          ) : (
            <Balance
              abbreviate={false}
              locale={currentLocale}
              privacy={privacyEnabled}
              showSymbol
              size="sm"
              variant="muted"
              value={fees?.deposit}
            />
          ),
        }}
      />
    </FlexList>
  );
};

export default LiquidityMigrationTransactionFees;
